import { render, staticRenderFns } from "./DisplayColumnSelector.vue?vue&type=template&id=1e954d85&scoped=true"
import script from "./DisplayColumnSelector.vue?vue&type=script&lang=ts"
export * from "./DisplayColumnSelector.vue?vue&type=script&lang=ts"
import style0 from "./DisplayColumnSelector.vue?vue&type=style&index=0&id=1e954d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e954d85",
  null
  
)

export default component.exports